// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_container__HAPlU {
  max-width: 600px;
  margin: 40px auto;
  padding: 32px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.10);
  text-align: center;
}
.Home_menuArea__UCUqx {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}
.Home_button__Nn5fs {
  background: linear-gradient(90deg, #4f8cff 0%, #2357c5 100%);
  color: #fff;
  font-weight: bold;
  border: none;
  border-radius: 24px;
  padding: 12px 36px;
  font-size: 1.1em;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(79,140,255,0.08);
  transition: background 0.2s, box-shadow 0.2s, transform 0.1s;
}
.Home_button__Nn5fs:hover, .Home_button__Nn5fs:focus {
  background: linear-gradient(90deg, #2357c5 0%, #4f8cff 100%);
  box-shadow: 0 4px 16px rgba(79,140,255,0.16);
  transform: translateY(-2px) scale(1.03);
}
`, "",{"version":3,"sources":["webpack://./src/Page/Home/Home.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,4DAA4D;EAC5D,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,4DAA4D;AAC9D;AACA;EACE,4DAA4D;EAC5D,4CAA4C;EAC5C,uCAAuC;AACzC","sourcesContent":[".container {\r\n  max-width: 600px;\r\n  margin: 40px auto;\r\n  padding: 32px 16px;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 12px rgba(0,0,0,0.10);\r\n  text-align: center;\r\n}\r\n.menuArea {\r\n  margin-top: 32px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  align-items: center;\r\n}\r\n.button {\r\n  background: linear-gradient(90deg, #4f8cff 0%, #2357c5 100%);\r\n  color: #fff;\r\n  font-weight: bold;\r\n  border: none;\r\n  border-radius: 24px;\r\n  padding: 12px 36px;\r\n  font-size: 1.1em;\r\n  cursor: pointer;\r\n  box-shadow: 0 2px 8px rgba(79,140,255,0.08);\r\n  transition: background 0.2s, box-shadow 0.2s, transform 0.1s;\r\n}\r\n.button:hover, .button:focus {\r\n  background: linear-gradient(90deg, #2357c5 0%, #4f8cff 100%);\r\n  box-shadow: 0 4px 16px rgba(79,140,255,0.16);\r\n  transform: translateY(-2px) scale(1.03);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Home_container__HAPlU`,
	"menuArea": `Home_menuArea__UCUqx`,
	"button": `Home_button__Nn5fs`
};
export default ___CSS_LOADER_EXPORT___;
